module.exports = __webpack_public_path__ + "static/media/volt.d18e1495.jpg";